(function (app, ng) {

    app.component("clientSidebar",
        {
            transclude: true,
            templateUrl: "/App/Client/Components/clientsidebar-template.html",
            controller: clientSidebarController,
            require: {
                parent: "^client"
            }
        });

    clientSidebarController.$inject = ["$mdDialog", "$rootScope", "$state", "modalService", "caseModalService", "personApi"];
    function clientSidebarController($mdDialog, $rootScope, $state, modalService, caseModalService, personApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                caseModalService,
                modalService,
                openFileViewer,
                deleteClient,
            });

        function openFileViewer($event) {
            var alert = $mdDialog.alert({
                focusOnOpen: false,
                templateUrl: "/App/Client/FileViewer/fileviewer-template.html",
                controller: "clientFileViewerController",
                controllerAs: "$ctrl",
                targetEvent: $event,
                clickOutsideToClose: false,
                locals: {
                    user: $ctrl.parent.currentUser,
                    client: $ctrl.parent.client
                },
                resolve: {
                    rootDirectory: ["directoryApi", function (directoryApi) {
                        return directoryApi.getPersonDirectory($ctrl.parent.client.Id).then(function (root) {
                            return directoryApi.getChildren(root.Id).then(function (children) {
                                return directoryApi.getFiles(root.Id).then(function (files) {
                                    ng.extend(root,
                                        {
                                            Children: children,
                                            Files: files,
                                            DisplayChildren: true
                                        });

                                    return root;
                                });
                            });
                        });
                    }]
                }
            });

            $mdDialog.show(alert);
        }

        function deleteClient($event) {
            $ctrl.modalService.confirmDeleteClient($event).then(function() {
                $ctrl.parent.ui.loading = true;
                personApi.delete($ctrl.parent.client.Id).then(function() {
                    $state.go("Home.Contacts");
                });
            });
        }

        $rootScope.$on("caseCreated",
            function (event, response) {
                $state.go("Home.Client.Case", { clientId: response.ClientId, caseId: response.Id });
            });
    }

})(window.app, window.angular); //jshint ignore:line